// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ob_ARWJ3r","root":"ob_AKv46J","sticky":"ob_ZKOSbb","isHidden":"ob_dvwcqV","isHeader":"ob_rXRxS6","border":"ob_InjMap","border__isVisible":"ob_7G45LJ"};